<div
  class="c-form__item u-layout-auto u-width-100"
  [ngClass]="{
    'c-form__error': errorMessage.length > 0,
    'c-form__prepend': prepend,
    'c-form__item--with-toggle': showVisibilityToggle
  }"
>
  <label [for]="label"
    >{{ label | lsTranslate }}
    <span *ngIf="required">*</span>
    <ls-info-setting-tooltip
      *ngIf="description"
      [tooltip]="description"
    ></ls-info-setting-tooltip>
  </label>
  <span *ngIf="prepend" class="c-form__prepend--label">{{ prepend }}</span>
  <div class="c-form__input-wrapper">
    <input
      (change)="textValueChanged($event)"
      (keyup)="textValueChanged($event)"
      (focus)="focused.emit()"
      (blur)="blurred.emit()"
      [attr.maxlength]="maxlength"
      [value]="text"
      [disabled]="disabled ? true : null"
      [pattern]="pattern"
      [placeholder]="placeHolder | lsTranslate"
      [type]="showVisibilityToggle && isValueVisible ? 'text' : type"
      [id]="label"
      [autocomplete]="autocomplete"
    />
    <button
      *ngIf="
        showVisibilityToggle && hasValue && (!formControl || formControl.dirty)
      "
      type="button"
      class="c-form__toggle-visibility"
      (click)="toggleVisibility()"
      [title]="
        isValueVisible
          ? ('Hide ' | lsTranslate) + label
          : ('Show ' | lsTranslate) + label
      "
      aria-label="Toggle field visibility"
      i18n-aria-label="Text input|Toggle field visibility button @@toggleVisibilityAriaLabel"
    >
      <i class="fa" [ngClass]="isValueVisible ? 'fa-eye-slash' : 'fa-eye'"></i>
    </button>
  </div>
  <div
    id="errorMessage"
    class="c-form__message"
    *ngIf="errorMessage.length > 0"
  >
    {{ errorMessage | lsTranslate }}
  </div>
</div>

<div
  ls-dynamic-translation
  id="This is a required field."
  i18n="Text input|Required field error message @@errorMessageRequiredText"
>
  This is a required field.
</div>
<div
  ls-dynamic-translation
  id="The entered text is too short."
  i18n="Text input|Minimum input length field error message @@errorMessageMinLengthText"
>
  The entered text is too short.
</div>
<div
  ls-dynamic-translation
  id="The Establishment Unit Number you entered is invalid. Please ensure it is a 10-digit number starting with 2-8."
  i18n="Text input|startsWithTwo8Format field error message @@startsWithTwo8FormatText"
>
  The Establishment Unit Number you entered is invalid. Please ensure it is a
  10-digit number starting with 2-8
</div>
<div
  ls-dynamic-translation
  id="Please enter a valid postal code in the format A1A 1A1 OR A1A1A1"
  i18n="Text input|canadianPostalCodePattern field error message @@canadianPostalCodePatternText"
>
  Please enter a valid postal code in the format A1A 1A1 OR A1A1A1
</div>
<div
  ls-dynamic-translation
  id="The check digit is incorrect. Check and try again."
  i18n="Text input|invalidBelgianNumberFormat field error message @@invalidBelgianNumberFormatText"
>
  The check digit is incorrect. Check and try again.
</div>
